import React from "react";
import "../css/MenuStart.css";
import {
    Typography,
    Grid,
    Button,
    Paper,
    makeStyles,
} from "@material-ui/core";

import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LowerbarState } from "../../model/lowerBarState";


import routes from "../../utils/routes.json";
import LogoIcon from "../components/svg/LogoIcon";
import PlayIcon from "../components/svg/PlayIcon";
import SelectedPlayIcon from "../components/svg/SelectedPlayIcon";

const useStyles = makeStyles((theme) => ({
    centerHorizontal: {
        marginTop: "5em",
        ["@media (max-height: 1180px)"]: {
            marginTop: "0rem",
        },
        marginLeft: "auto",
        marginRight: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    grid: {
        backgroundColor: theme.palette.primary.main,
        height: "100%",
    },
    paper: {
        backgroundColor: "unset",
    },
    fontSize: {
        fontSize: "3rem",
        ["@media (max-height: 1217px)"]: {
            fontSize: "2rem",
        },
        ["@media (max-height: 1130px)"]: {
            fontSize: "1.5rem",
        },
        ["@media (max-height: 750px)"]: {
            fontSize: "0.4rem",
        },
        ["@media (max-width: 1000px)"]: {
            fontSize: "3rem",
        },
        ["@media (max-width: 600px)"]: {
            fontSize: "2rem",
        },
        ["@media (max-width: 390px)"]: {
            fontSize: "0.4rem",
        },
    },
    button: {
        border: "shape",
        color: "white",
    },
    design: {
        display: "flex", 
        backgroundColor: "white", 
        color: "black", 
        border: "shape", 
        borderRadius: "1rem",
        height: "8rem",
        ["@media (max-height: 980px)"]: {
            height: "6rem",
        },
        ["@media (max-height: 815px)"]: {
            height: "4rem",
        },
        width: "100%",
        margin: "auto",
    }
}));

export default function MenuStart(): JSX.Element {
    const { t } = useTranslation();
    const classes = useStyles();
    return (
        <MainScreen lower={true} back={false} lowerBarState={LowerbarState.MENU}>
            <Grid container direction="column" justify="space-evenly" id={"MenuButtonsGrid"}>
                <Paper elevation={0} className={`${classes.centerHorizontal} ${classes.fontSize}`}>
                    <LogoIcon />
                    <Typography variant="h1">
                        QUIZZERO
                    </Typography>
                </Paper>
                <Link to={routes.categories} className={"MenuButtonLink"}>
                    <Button color="primary" className={`${"MenuButton"} ${classes.fontSize} ${classes.design}`} size="small">
                        <Typography variant="h4">
                            {t("main-menu.play")}
                        </Typography>
                    </Button>
                </Link>
                <Link to={{ pathname: routes.dailyquestion, state: { categoryIds: ["17", "18", "19", "20", "21"] } }} className={"MenuButtonLink"}>
                    <Button color="primary" className={`${"MenuButton"} ${classes.fontSize} ${classes.design}`} size="small">
                        <Typography variant="h4">
                            {t("main-menu.dailyquestion")}
                        </Typography>
                    </Button>
                </Link>
                <Link to={routes.practice_categories} className={"MenuButtonLink"}>
                    <Button color="primary" className={`${"MenuButton"} ${classes.fontSize} ${classes.design}`} size="small">
                        <Typography variant="h4">
                            {t("main-menu.practice")}
                        </Typography>
                    </Button>
                </Link>
                <Link to={routes.tournament_categories} className={"MenuButtonLink"}>
                    <Button color="primary" className={`${"MenuButton"} ${classes.fontSize} ${classes.design}`} size="small">
                        <Typography variant="h4">
                            {t("main-menu.tournament")}
                        </Typography>
                    </Button>
                </Link>
            </Grid>
        </MainScreen>
    );
}
